// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9066 ? "dc112a36" : chunkId) + "." + {"6223":"6a57865701651e78","9066":"10c77fd4b52203c7"}[chunkId] + ".js";
};